<script>
	import NotificationsList from '../parts/notifications-list.svelte';
	import { t, Verbiage } from '@infinitro/content';
	import { closeThisModal, ModalDialog, stateOpenModal } from '@infinitro/global';
	import { Modal } from '@infinitro/modal';

	export const thisModal = ModalDialog.Notifications;
</script>

{#if $stateOpenModal === thisModal}
	<div class="notifications-modal">
		<Modal title={$t(Verbiage.your_notifications)} closeModal={() => closeThisModal(thisModal)}>
			<NotificationsList />
		</Modal>
	</div>
{/if}
